import { render } from "./ContentHeaderSectionButton.vue?vue&type=template&id=b47ea97c&scoped=true"
import script from "./ContentHeaderSectionButton.vue?vue&type=script&lang=js"
export * from "./ContentHeaderSectionButton.vue?vue&type=script&lang=js"

import "./ContentHeaderSectionButton.vue?vue&type=style&index=0&id=b47ea97c&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b47ea97c"]])

export default __exports__